import React, { useEffect, useState } from "react";
import {
  Card,
  Space,
  Row,
  Col,
  DatePicker,
  Button,
  Switch,
  Select,
} from "antd";
import { FilterOutlined, SyncOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Option } = Select;

const FilterBar = ({
  dateRange,
  onDateChange,
  onSearch,
  loading,
  isClustering,
  onClusteringChange,
  type,
  setType,
}) => {
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [refreshInterval, setRefreshInterval] = useState(300); // 5 minutes default
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (autoRefresh) {
      const interval = setInterval(onSearch, refreshInterval * 1000);
      setTimer(interval);
      return () => clearInterval(interval);
    } else if (timer) {
      clearInterval(timer);
    }
  }, [autoRefresh, refreshInterval, onSearch]);

  const refreshOptions = [
    { label: "30 secondes", value: 30 },
    { label: "1 minute", value: 60 },
    { label: "5 minutes", value: 300 },
    { label: "15 minutes", value: 900 },
    { label: "30 minutes", value: 1800 },
  ];

  return (
    <div className="w-full bg-white">
      <Card className="shadow-sm">
        <Space direction="vertical" size="middle" className="w-full">
          <Row gutter={16} align="middle" className="items-center">
            {/* Date Range Filter */}
            <Col xs={24} sm={12} md={6}>
              <div className="space-y-2">
                <RangePicker
                  value={dateRange}
                  onChange={onDateChange}
                  className="w-full"
                  placeholder={["Date début", "Date fin"]}
                  showTime={{ format: "HH:mm" }}
                />
              </div>
            </Col>

            {/* Search Button */}
            <Col xs={24} sm={12} md={4}>
              <div className="h-full flex items-end">
                <Button
                  type="primary"
                  icon={<FilterOutlined />}
                  onClick={onSearch}
                  loading={loading}
                  className="w-full"
                >
                  Rechercher
                </Button>
              </div>
            </Col>

            {/* Auto Refresh Controls */}
            <Col xs={24} sm={12} md={8}>
              <div className="flex items-center space-x-4">
                <Switch
                  checked={autoRefresh}
                  onChange={setAutoRefresh}
                  checkedChildren={<SyncOutlined spin={autoRefresh} />}
                  unCheckedChildren={<SyncOutlined />}
                />
                <Select
                  value={refreshInterval}
                  onChange={setRefreshInterval}
                  className="w-40"
                  disabled={!autoRefresh}
                >
                  {refreshOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>

                <Select
                  placeholder="Type"
                  value={type}
                  onChange={(value) => setType(value)}
                  className="w-40"
                  allowClear
                >
                  <Select.Option value="warning">Avertissement</Select.Option>
                  <Select.Option value="infraction">Infraction</Select.Option>
                </Select>
              </div>
            </Col>

            {/* Clustering Toggle */}
            <Col xs={24} sm={12} md={6}>
              <div className="flex items-center space-x-2">
                <Switch
                  checked={isClustering}
                  onChange={onClusteringChange}
                  checkedChildren="Regroupement Activé"
                  unCheckedChildren="Regroupement Désactivé"
                />
              </div>
            </Col>
          </Row>
        </Space>
      </Card>
    </div>
  );
};

export default FilterBar;
